// app/javascript/projects/components/TeamModalMain.jsx

import React from 'react';
import { Button } from 'ui'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ColorConstants from 'constants/ColorConstants'
import UserCircle from './UserCircle'
import { useSubscription, useSeats } from '../../hooks/subscriptions/queries';
import { useCurrentUser } from '../../hooks/users/queries';
import { calculateInitials } from '../../utils/userUtils';

const BORDER_COLOR = "1px solid " + ColorConstants.ULTRA_LIGHT_GREY;
const BUTTON_WIDTH = 300;

function TeamModalMain({ navigateToPage, PAGES }) {
  const { data: subscription } = useSubscription();
  const { data: currentUser } = useCurrentUser();
  const { data: seatsData } = useSeats(subscription?.id);
  
  const seats = seatsData?.seats || [];
  const disabled = subscription?.status === 'canceled';

  const memberClick = (seatID) => {
    navigateToPage(PAGES.MEMBER_DETAIL, { seatId: seatID });
  };

  const addTeamMember = () => {
    navigateToPage(PAGES.ADD_MEMBERS);
  };

  const createRow = (name, email, initials, seatID) => {
    return (
      <div>
        <div style={{float:"left"}}>
          <UserCircle
            initials={initials}
          />
        </div>
        <div style={{marginLeft:12, marginTop:2, float:"left"}}>
          <h5 style={{marginBottom:2}}>{name}</h5>
          <p style={{pading:0}}>{email}</p>
        </div>

        {seatID && <div className='seatSelect' style={{float:"right", paddingTop:15}}>
          <ChevronRightIcon onClick={() => memberClick(seatID)} style={{color:ColorConstants.LIGHT_GREY, cursor:"pointer", fontSize:20}}/>
        </div> }
        <div style={{clear:"both"}}></div>
      </div>
    );
  };

  const userHtml = seats.map((seat) => {
    if (seat.user) {
      return (
        <div style={{borderBottom: BORDER_COLOR, padding:10}} key={seat.id}>
          {createRow(seat.user.name, seat.user.email, calculateInitials(seat.user), seat.id)}
        </div>
      );
    }
    else {
      return <div key={seat.id}></div>
    }
  });

  return (
    <div>
      <h4>Manage Team</h4>

      <div style={{borderBottom: BORDER_COLOR, borderTop: BORDER_COLOR, padding:10, marginTop:30}}>
        {createRow(currentUser?.name || "You", "Owner", calculateInitials(currentUser), null)}
      </div>

      {userHtml}

      <div style={{margin:"0 auto", width:"100%", width:BUTTON_WIDTH, paddingTop:50}}>
        <Button variant="white" style={{width:BUTTON_WIDTH}} onClick={addTeamMember} disabled={disabled}>Add Team Member</Button>
      </div>
    </div>
  );
}

export default TeamModalMain;